<div>
    <div>
        @if(data?.codeBlocks?.length) {
            @for(item of data?.codeBlocks; track item?.title) {
                <div class="mb-2">
                    <app-code-snippet [title]="item.title" [code]="item.code"></app-code-snippet>
                </div>
            }
        } @else {
            <app-code-snippet [code]="data?.CodeSnippets"></app-code-snippet>
        }

    </div>
    <div>
        <div class="header-4 mt-4 mb-2"> Recommendations </div>
        @for(item of data?.recommendations; track item) {
            <div class="recommendation-card mb-2 card" [ngClass]="{ 'highlight': item.highlight }">
                {{ item }}
            </div>
        }
    </div>
</div>